import getQueryList from './getQueryList';

export default function checkIsFieldShownInQuery(fieldReference, query = {}) {
  if (!fieldReference || !query.show_fields) return false;

  return getQueryList(query.show_fields).includes(fieldReference);
}
